import React, { useImperativeHandle } from 'react'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import useAtomWithRef from '../../../../utils/useAtomWithRef'
import { videoElementAtom } from '../atoms'

/*======================== React component ===================================*/

const ClickRecognizer = React.forwardRef<HTMLDivElement, {}>((_, ref): JSX.Element => {
  const areaRef = useRef<HTMLDivElement>(null)
  const [videoElementRef] = useAtomWithRef(videoElementAtom)

  useImperativeHandle(ref, () => areaRef.current!)

  useEffect(() => {
    const eventListener = () => {
      if (!videoElementRef.current) {
        return
      }

      console.log('VEX: onClick recognizer')
      // If the video is paused, play it. Otherwise, pause it.
      if (videoElementRef.current!.paused) {
        console.log('VEX: play')
        videoElementRef.current.play()
      } else {
        console.log('VEX: pause')
        videoElementRef.current.pause()
      }
    }
    areaRef.current?.addEventListener('click', eventListener)
    return () => {
      areaRef.current?.removeEventListener('click', eventListener)
    }
  }, [areaRef.current])

  return <Area ref={areaRef} />
})
ClickRecognizer.displayName = 'ClickRecognizer'

export default ClickRecognizer

/*======================== Styled components =================================*/

const Area = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  //TODO: Calculate it with a ref and useLayoutEffect.
  height: calc(100% - 70px);
  pointer-events: all;
`
